module.exports = __webpack_public_path__ + "static/micromart-7bbe90fbe5614cfa9ada4b2903691e65.jpg";